import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
// import SideNav from "../../components/commonComponents/Sidebar/SideNav";
import TableauDash from "../../components/commonComponents/TableauDashboard/TableauDash";
import { StickyTopRowStack, StickyTopRowStackSpaceBetween, StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import StoreFilter from "../../components/commonComponents/Filters/StoreFilter";
import DateRangeFilter from "../../components/commonComponents/Filters/DateRangeFilter";
// ,
import { checkWorkbookFilters, filterRangeValue } from "../../api_calls/TableauVisuals";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie, checkWorkSpaceFromCookies } from "../../api_calls/userManagement";
import { findLandingOverviewEmbed, landingOverviewFiltersEnabled, findStoreIds, resetListingCaches } from "../../api_calls/utils";
import ActionButton from "../../components/commonComponents/Buttons/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import {
  dbFormatDate,
  formatToStandardDate,
  resetBrandReportView,
  standardFormatToday,
  storeListOptionsForFilter,
  yesterdayDate,
} from "../../api_calls/utils";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import DateRangeInputFields from "../../components/commonComponents/Filters/DateRangeInputFields";
import { deleteItems } from "../../Store/actions";
import { loadStorePeriods } from "../../api_calls/campaigns";
import { setBatchLoadingStatus } from "../../api_calls/requestConfig";
import { resolveEmbeddableNumberRoot } from "../../api_calls/retailerSelection";

const Overview = () => {
  const [userInfo, setUserInfo] = React.useState({});
  const userStateDate = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const { date_range_start_date, date_range_end_date } = userStateDate;
  // null until we know whether this workspace shows the store/date filters
  const [filterEnabled, setFilterEnabled] = React.useState(null);
  const numberRoot = resolveEmbeddableNumberRoot(userInfo.root_company_id);
  // Empty until the user cookie has been read. The id then stays stable for this visit.
  const landingEmbedId = typeof userInfo.root_company_id !== "undefined" ? findLandingOverviewEmbed() : "";


  const { minSelectableDate, maxSelectableDate } = React.useMemo(() => {
    const today = standardFormatToday();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const start = date_range_start_date
      ? new Date(date_range_start_date)
      : new Date("2023-02-07");

    const end = date_range_end_date
      ? new Date(date_range_end_date)
      : dbFormatDate(yesterday);

    return {
      minSelectableDate: start,
      maxSelectableDate: end,
    };
  }, [date_range_start_date, date_range_end_date]);

  const dashboardVariables = () => {
    let overviewDashboardVariables = {};

    if (typeof userStateDate.embedded_landing_page_stores !== "undefined" && typeof userStateDate.embedded_landing_page_stores.store_ids !== "undefined" && userStateDate.embedded_landing_page_stores.store_ids.length !== 0) {
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        Stores: userStateDate.embedded_landing_page_stores.store_ids,
      }

    }

    if (typeof userStateDate.embedded_landing_page_date !== "undefined") {
      const endDate = new Date(userStateDate?.embedded_landing_page_date.to);
      endDate.setDate(endDate.getDate() + 1); // add one day to
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        Date: {
          from: userStateDate?.embedded_landing_page_date.from,
          to: endDate
        },
      }
    }

    return overviewDashboardVariables;
  }

  React.useEffect(() => {
    resetBrandReportView();
    resetListingCaches();
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    // Filters follow the chosen landing version, not the company root.
    setFilterEnabled(landingOverviewFiltersEnabled(findLandingOverviewEmbed()));
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);

  // When store/date filters are hidden, this page still needs periods so the
  // dashboard can wait on store_dates.
  React.useEffect(() => {
    if (filterEnabled !== false) {
      return;
    }

    dispatchAction(deleteItems(["store_dates"]));
    loadStorePeriods("overview");
  }, [filterEnabled]);

  return typeof userInfo.root_company_id !== "undefined" ? (
    <StyledMainBox component="main">
      {/* ------------- filters -------------- */}
      <StickyTopRowStackSpaceBetween
        direction={"row"}
        spacing={2}
        sx={{
          justifyContent: "flex-end",
        }}
      >
        {/* ---------- dashboard filters ----------- */}
        {
          filterEnabled && (
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", ml: "auto" }}>
              {/* ------- stores filter ----------- */}
              <Box sx={{ width: 250 }}>
                <StoreFilter
                  usedFor={"overview"}
                  reduxKeywordToSaveValue={"embedded_landing_page_stores"}
                />
                {/* <StoreFilter usedFor={"overview"} fieldName="Id Store" vizId={"generalKpiViz"} /> */}
              </Box>
              {/* ------------ day timestamp filter ------------ */}
              {typeof userStateDate.date_range_start_date !== "undefined" && (
                <Box>
                  <DateRangeInputFields
                    minSelectableDate={minSelectableDate}
                    maxSelectableDate={maxSelectableDate}
                    reduxKeywordToSaveValue={"embedded_landing_page_date"}
                  />
                </Box>
              )}
            </Box>
          )
        }
      </StickyTopRowStackSpaceBetween>
      {/* -------- tableau dashboard -------- */}
      <Box height={1} />
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" &&
          typeof userStateDate.store_dates !== "undefined" &&
          (filterEnabled === false || typeof userStateDate.embedded_landing_page_stores !== "undefined") && (
          <Dashboard
            key={`${landingEmbedId}-${numberRoot}`}
            embedDashboardId={landingEmbedId}
            variables={dashboardVariables()}
            filterConfig={{
              "number_root": numberRoot,
            }} />
        )}
      </Grid>
    </StyledMainBox>
  ) : (
    <></>
  );
};

export default AccessControl(Overview, ["overview_can_view"], [], ["overview"]);
